import { createContext } from "react"

export const ThemeContext = createContext({
  mode: undefined,
  theme: null,
  setTheme: () => {},
  applyTheme: (value) => { },
  setStyle: (value) => {}
})
